import React from "react";
import "../styles/confirm-modal.css";

export default function ConfirmChangesModal({
  open,
  onClose,
  onConfirm,
  title,
  subtitle,
  items = [],
  warnings = [],
  allowEmptyConfirm = false,
  confirmLabel = "Potvrdit a odeslat",
}) {
  if (!open) return null;

  const hasSendableItems = items.some((i) => i.willSend);
  const confirmDisabled = !allowEmptyConfirm && !hasSendableItems;

  return (
    <div className="modal-backdrop">
      <div className="modal-card">
        <div className="modal-header">
          <h3>{title}</h3>
          {subtitle && <p className="muted">{subtitle}</p>}
        </div>

        {warnings.length > 0 && (
          <div className="modal-warnings">
            {warnings.map((w, i) => (
              <div key={i} className="warning-row">{w}</div>
            ))}
          </div>
        )}

        {items.length > 0 ? (
          <div className="modal-table">
            <div className="modal-table-head">
              <div>Stanice</div>
              <div>Produkt</div>
              <div>Měna</div>
              <div>Původní</div>
              <div>Nová</div>
              <div>Zdroj</div>
            </div>

            {items.map((it, idx) => (
              <div
                key={idx}
                className={`modal-table-row ${it.willSend ? "" : "row-disabled"}`}
              >
                <div>{it.stationName}</div>
                <div>{it.fuel}</div>
                <div>{it.currency}</div>
                <div>{it.originalValue ?? "—"}</div>
                <div>
                  <b>{it.newValue ?? "—"}</b>
                </div>
                <div>{it.source === "derived" ? "dopočítáno" : "ručně"}</div>
              </div>
            ))}
          </div>
        ) : (
          <div className="modal-empty-state">
            Nejsou zde žádné změněné položky. Akce bude uložena jako kontrola beze změn.
          </div>
        )}

        <div className="modal-actions">
          <button type="button" className="btn-secondary" onClick={onClose}>
            Zrušit
          </button>

          <button
            type="button"
            className="btn-primary"
            onClick={onConfirm}
            disabled={confirmDisabled}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}